import { render, staticRenderFns } from "./GiftCarrier.vue?vue&type=template&id=8294632c&scoped=true&"
import script from "./GiftCarrier.vue?vue&type=script&lang=js&"
export * from "./GiftCarrier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8294632c",
  null
  
)

export default component.exports